<template>
  <el-container class="is-vertical" style="flex-shrink: 0">
    <el-main class="login-register">
      <div class="headings">
        <h2>Create student account</h2>
      </div>
      <div class="form-cnt">
        <div class="d-flex">
          <div class="inputs d-flex">
            <el-form ref="registerForm" :model="register" :rules="rules">
              <label>
                <span>Username</span>
                <el-form-item prop="username">
                  <el-input
                          type="email"
                          placeholder="Enter your username"
                          v-model="register.username">
                  </el-input>
                </el-form-item>
              </label>
              <label>
                <span>Email</span>
                <el-form-item prop="email">
                  <el-input
                          type="email"
                          placeholder="Enter your email"
                          v-model="register.email">
                  </el-input>
                </el-form-item>
              </label>
              <label>
                <span>Password</span>
                <el-form-item prop="password">
                  <el-input
                          type="password"
                          placeholder="Enter your password"
                          v-model="register.password">
                  </el-input>
                </el-form-item>
              </label>
              <div class="actions">
                <el-button type="success" @click="submitForm('registerForm')">Sign up</el-button>

              </div>
            </el-form>
          </div>
          <div class="divider"></div>
          <div class="socials">
            <!-- <a href="#" class="auth-button facebook">
                <span class="icon"><img src="/icons/facebook.svg" alt=""></span>
                <span class="text">Log in with <b>Facebook</b></span>
            </a> -->
            <a href="/users/login/google" class="auth-button google-plus">
              <span class="icon"><img src="/static/icons/google-plus.svg" alt=""></span>
              <span class="text">Log in with <b>Google</b></span>
            </a>
            <!-- <a href="#" class="auth-button twitter">
                <span class="icon"><img src="/icons/twitter.svg" alt=""></span>
                <span class="text">Log in with <b>Twitter</b></span>
            </a> -->
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'Login',
    data () {
      return {
        register: {
          username: "",
          email: "",
          password: "",
        },
        rules: {
          username: [
            {required: true, message: 'Please input username', trigger: 'blur'},
          ],
          email: [
            {required: true, message: 'Please input email address', trigger: 'blur'},
            {type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change']},
          ],
          password: [
            {required: true, message: 'Password should not be blank', trigger: ['blur', 'change']},
          ]

        }
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.register.email = this.register.email.toLowerCase();
            this.axios.post(this.$store.state.API_URL+'auth/local/register', this.register).then((response) => {
              this.$store.state.user = response.data.user;
              this.$store.state.jwt = response.data.jwt;
              localStorage.setItem('jwt', response.data.jwt);

              this.$store.commit("setState", {loggedIn: true});
              this.$router.push('/my-library');
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/RegisterStudent.vue